import { Navigate, RouteObject } from "react-router-dom";
import { CreateNewPassword, ErrorPage, ForgotPassword, Home, SignIn, SignUp } from "../pages";
import SuccessPage from "../pages/auth/sign-up/SuccessPage";
import ParentDashboardLayout from "./ParentDashboardLayout";
import CertificateView from "../pages/CertificateView";
import DownloadCertificate from "../pages/DownloadCertificate";
import PreviewDownloadCertificate from "../pages/PreviewDownloadCertificate";
import SingleReportView from "../pages/dashboard/home/SingleReportView";
import Redirect from "../pages/auth/Redirect";
import Cart from "../pages/dashboard/home/Cart";
import ReceiptView from "../pages/ReceiptView";
import PaymentHistory from "../pages/dashboard/home/PaymentHistory";
import ChildrenPage from "../pages/dashboard/children/ChildrenPage";
import ActivityPage from "../pages/dashboard/activity/ActivityPage";
import ReportsPage from "../pages/dashboard/reports/ReportsPage";
import ProfilePage from "../pages/dashboard/profile/ProfilePage";
import SettingsPage from "../pages/dashboard/settings/SettingsPage";
import PrivateLessonsPage from "../pages/dashboard/private-lessons/PrivateLessonsPage";

const routes: RouteObject[] = [
    { path: '/', element: <Navigate to="/parent/sign-in" replace /> },
    { path: '/parent/sign-up', element: <SignUp /> },
    { path: '/parent/sign-in', element: <SignIn /> },
    { path: '/auth/redirect', element: <Redirect /> },
    { path: '/parent/forgot-psd', element: <ForgotPassword /> },
    { path: '/parent/create-psd', element: <CreateNewPassword /> },
    { path: '/parent/certificate', element: <CertificateView /> },
    { path: '/parent/certificate/download/:id', element: <DownloadCertificate /> },
    { path: '/parent/certificate/preview/:id', element: <PreviewDownloadCertificate /> },
    { path: '/parent/report/preview/:id', element: <SingleReportView /> },
    { path: '/parent/receipt/:id', element: <ReceiptView /> },
    { path: '/cart/:id/preview', element: <Cart /> },
    {
        element: <ParentDashboardLayout />,
        children: [
            { path: '/parent/home', element: <Home /> },
            { path: '/parent/children', element: <ChildrenPage /> },
            { path: '/parent/private-lessons', element: <PrivateLessonsPage /> },
            { path: '/parent/activity', element: <ActivityPage /> },
            { path: '/parent/reports', element: <ReportsPage /> },
            { path: '/parent/profile', element: <ProfilePage /> },
            { path: '/parent/settings', element: <SettingsPage /> },
            { path: '/parent/payment-history', element: <PaymentHistory /> },
        ],
    },
    { path: '/success', element: <SuccessPage /> },
    { path: '*', element: <ErrorPage /> },
];

export { routes };
